module.exports = __webpack_public_path__ + "static/media/Video-Icon.2bf25c41.png";